<ndt-call-cost-detail-view
   [callCost]="callCost$ | async"
   [callCostPrivileges]="callCostPrivileges$ | async"
   [callState]="callState$ | async"
   [isSystemUser]="isSystemUser$ | async"
   [selectedAccountName]="selectedAccount$ | async"
   (formSaveCanceled)="onFormSaveCanceled()"
   (deleteCallCost)="onDeleteCallCost($event)"
   (formSubmitted)="onFormSubmitted($event)"
></ndt-call-cost-detail-view>
